module.exports = __webpack_public_path__ + "ba94e1886ccd4a5946fb619597b07ce2.png";